import { Button } from '@material-tailwind/react'
import React from 'react'

const TopArea = ({ handleWarehouseModal }) => {
  return (
    <div className='mb-5 mt-3 flex justify-end'>
      <Button onClick={handleWarehouseModal} className='rounded-full bg-[#f97316] px-6 py-3 text-xs font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(249,115,22,0.22)] hover:bg-[#ea580c]'>
        + Add Warehouse
      </Button>
    </div>
  )
}

export default TopArea
